import { memo } from 'react';
import tw from 'twin.macro';

const VideoInPerformance = ({
  videoPlayerRef,
  src,
  isRightSide,
  loop,
  autoPlay,
  compact,
  isStackedMobile,
  ...rest
}) => {
  return (
    <video
      preload="metadata"
      // iOS Safari hijacks any <video> into its native fullscreen player the
      // moment it starts playing unless playsinline is set. webkit-playsinline
      // is the pre-iOS 10 spelling — harmless elsewhere, still needed on old
      // iPhones. Both must stay for the reference video to render in place.
      playsInline
      webkit-playsinline="true"
      disablePictureInPicture
      ref={videoPlayerRef}
      css={[
        compact
          ? tw`w-[320px] h-[224px] z-10 object-contain rounded-[10px] bg-black shadow-[0_12px_28px_rgba(0,0,0,0.35)]`
          : isStackedMobile
            ? tw`relative w-full h-full object-contain bg-black`
            : tw`h-full bg-black/90 w-[100vw] max-h-[100vh] absolute left-0 top-0 object-contain`,
        isRightSide ? tw`scale-x-[-1]` : tw``,
      ]}
      tw="transition-all duration-500 ease-in-out"
      width={648}
      autoPlay={autoPlay}
      loop={loop}
      height={480}
      src={src}
      muted
      {...rest}
    />
  );
};
export default memo(VideoInPerformance);
